<!-- <div *ngIf="!reportData.isExport" class="col-sm-2"></div> -->
<div class="main-slide-report">
  <div class="main-div-top">
    <div
      class="logo-div d-flex flex-column flex-md-row justify-content-start justify-content-md-between align-items-start align-items-md-center"
    >
      <div class="m-0 p-0">
        <img [src]="piqetLogo" alt="Piqet logo" />
      </div>
      <div class="m-0 pt-4 align-items-end">
        <img
          [src]="reportData?.organizationLogo"
          id="organizationLogo"
          alt="Organization image"
          align="right"
        />
      </div>
    </div>
  </div>

  <div class="main-contant">
    <div class="maintext-heading">
      <span class="purpleProjectName">{{ mainProjectName | titlecase }}</span>
      {{ remainingProjectName | titlecase }}
      -
      <br />
      {{ reportResource.lblDetailedReport }}
    </div>
  </div>

  <div class="bottom-contant">
    <div class="">Generated by</div>
    <div class="">George heathcote</div>
    <div class="">Other.side studio</div>
  </div>

  <div class="last-bottom-contant">
    <div class="">PIQET project code : {{ reportData?.projectCode }}</div>
    <div class="">Report generated : {{ getFormateDate(reportData?.reportGeneratedDate) }}</div>
    <div class="">Software version : PIQET {{ reportData?.softwareVersion }}</div>
  </div>

  <div class="row table-div page-break">
    <div class="col-12 table-content">
      <table class="table" style="margin-left: -100px">
        <tr style="text-align: center">
          <td width="15%"></td>
          <ng-container *ngIf="reportData.scenarioImages.length > 0">
            <ng-container *ngIf="reportData.scenarioImages.length > 2; else lessThanTwoImages">
              <ng-container
                *ngFor="let image of reportData.scenarioImages.slice(0, 2); let i = index"
              >
                <td>
                  <img [src]="generateImagePath(image.imageName)" style="max-height: 500px" />
                </td>
              </ng-container>
            </ng-container>
            <ng-template #lessThanTwoImages>
              <ng-container *ngFor="let image of reportData.scenarioImages">
                <td>
                  <img
                    [src]="generateImagePath(image.imageName)"
                    class="mr36 fr"
                    style="max-height: 500px; margin-left: -197px; float: left"
                  />
                </td>
              </ng-container>
            </ng-template>
          </ng-container>
        </tr>
        <tr style="font-family: 'Neue Montreal'; font-size: 50px; text-align: center">
          <td width="20%"></td>
          <ng-container *ngIf="reportData.scenarioImages.length < 2; else otherData">
            <ng-container *ngFor="let image of reportData.scenarioImages; let i = index">
              <td>
                <p style="margin-left: -197px; float: left" class="paragraphTitle">
                  {{ image.scenarioname }}
                </p>
              </td>
            </ng-container>
          </ng-container>
          <ng-template #otherData>
            <ng-container
              *ngFor="let image of reportData.scenarioImages.slice(0, 2); let i = index"
            >
              <td>
                <p class="uppercase">{{ image.scenarioname }}</p>
              </td>
            </ng-container>
          </ng-template>
        </tr>
        <tr style="text-align: center; margin-left: 50px; margin-top: 50px">
          <td width="20%"></td>
          <ng-container *ngIf="reportData.scenarioImages">
            <ng-container *ngFor="let image of reportData.scenarioImages.slice(2)">
              <td>
                <img [src]="image.imageName" style="height: 150px; width: 150px; color: #fff" />
              </td>
            </ng-container>
          </ng-container>
        </tr>
        <tr style="font-family: 'Neue Montreal'; font-size: 50px; text-align: center">
          <td width="20%"></td>
          <ng-container *ngIf="reportData.scenarioImages">
            <ng-container *ngFor="let image of reportData.scenarioImages.slice(2); let i = index">
              <td>
                <p class="scenarionameParagraphTitle">{{ image.scenarioname }}</p>
              </td>
            </ng-container>
          </ng-container>
        </tr>
      </table>
    </div>
  </div>

  <div class="page-break">
    <div>
      <div class="headingTitle setFontWeight">Result summary</div>
    </div>
    <div>
      <canvas
        baseChart
        [datasets]="spiderChartData"
        [type]="'radar'"
        [labels]="spiderChartLabels"
        [options]="spiderChartOptions"
        [plugins]="doughnutChartPlugins"
      >
      </canvas>
    </div>
  </div>

  <div>
    <ng-container
      *ngFor="
        let indicatorDetail of reportData.lifeCycleStageContributionImpactItems;
        let i = index
      "
    >
      <div class="page-break"></div>
      <ng-container
        *ngIf="reportData.spiderChartItems?.scenarioListForAnnumImpact.length != 0; else elseBlock"
      >
        <ng-container *ngIf="indicatorDetail.indicatorId === 1; else elseScenario">
          <div>
            <div class="headingTitle setFontWeight">Gloabal warming</div>
          </div>
        </ng-container>
        <ng-template #elseScenario>
          <div>
            <div class="headingTitle setFontWeight">{{ indicatorDetail.indicatorName }}</div>
            <br />
          </div>
        </ng-template>
      </ng-container>
      <ng-template #elseBlock>
        <ng-container *ngIf="indicatorDetail.IndicatorId === 1; else elseScenarioSecond">
          <div>
            <div class="headingTitle setFontWeight">Gloabal warming</div>
          </div>
        </ng-container>
        <ng-template #elseScenarioSecond>
          <div>
            <div class="headingTitle setFontWeight">
              {{ getIndicatorName(indicatorDetail.IndicatorId) }}
            </div>
          </div>
        </ng-template>
      </ng-template>

      <div class="row table-div">
        <div class="col-12 table-content">
          <table class="table">
            <tr>
              <td width="18%"></td>
              <td width="25%">
                <p class="paragraphTitle mr36 ta-r" style="text-align: right">
                  {{ indicatorDetail.indicatorUnitName }}
                </p>
                <br />
                <p class="paragraphTitle">
                  <img
                    [src]="indicatorImage[i]"
                    class="mr36 fr"
                    style="height: 50px; width: 50px"
                  />
                </p>
              </td>
              <td width="25%">
                <p class="paragraphTitle mr36 ta-r">Percentage change from baseline</p>
                <p class="paragraphTitle mr36 ta-r">%</p>
              </td>
              <td width="25%">
                <p class="paragraphTitle mr36 ta-r" style="margin-top: 10px">
                  No. of {{ getTreeText(i) }} saved annually
                </p>
                <p class="paragraphTitle">
                  <img class="mr36 fr" style="height: 50px; width: 50px" [src]="imagelist[i]" />
                </p>
              </td>
              <td width="20px"></td>
            </tr>

            <ng-container *ngFor="let scenarioimage of reportData.scenarioImages; let k = index">
              <tr>
                <td width="18%">
                  <img
                    [src]="generateImagePath(scenarioimage.imageName)"
                    style="width: 50px; height: 50px"
                  />
                  <span class="scenarioname">{{ scenarioimage.scenarioname }}</span>
                </td>
                <td width="18%">
                  <span class="mr36 fr scenarioname">{{ getImpact(getScenarioBasetotal(k)) }}</span>
                </td>
                <td width="25%">
                  <ng-container
                    *ngIf="
                      scenarioimage.scenarioname == reportData.baseScenarioName;
                      else elseBlock1
                    "
                  >
                    <span class="mr36 fr scenarioname">baseline</span>
                  </ng-container>
                  <ng-template #elseBlock1>
                    <div *ngIf="getTotalImpact(i, scenarioimage) >= 0; else elseBlock2">
                      <span class="mr36 fr scenarioname" style="color: darkgreen"
                        ><b>{{ getTotalImpact(i, scenarioimage) }}%</b></span
                      >
                    </div>
                  </ng-template>
                  <ng-template #elseBlock2>
                    <div>
                      <span class="mr36 fr scenarioname" style="color: darkgreen"
                        ><b>{{ getTotalImpactAbs(i, scenarioimage) }} %</b></span
                      >
                    </div>
                  </ng-template>
                </td>
                <td width="30%">
                  <ng-container
                    *ngIf="
                      scenarioimage.scenarioname == reportData.baseScenarioName;
                      else elseBlockOther1
                    "
                  >
                    <span class="mr36 fr scenarioname">baseline</span>
                  </ng-container>
                  <ng-template #elseBlockOther1>
                    <div *ngIf="getEuivalanceImpact(i, scenarioimage) >= 0; else elseBlockOther2">
                      <span class="mr36 fr scenarioname"
                        >{{ getImpact(getEuivalanceImpact(i, scenarioimage)) }}
                      </span>
                    </div>
                  </ng-template>
                  <ng-template #elseBlockOther2>
                    <div *ngIf="getEuivalanceImpact(i, scenarioimage) >= 0; else elseBlockOther2">
                      <span class="mr36 fr scenarioname"
                        >{{ getImpact(getEuivalanceImpactAbs(i, scenarioimage)) }}
                      </span>
                    </div>
                  </ng-template>
                </td>
                <td width="20px"></td>
              </tr>
            </ng-container>
          </table>
        </div>
      </div>
    </ng-container>
  </div>
</div>
<!-- <div *ngIf="!reportData.isExport" class="col-sm-2"></div> -->
